import { TimezoneFormData } from '../Types/Types'

export const MapToFormState = (timezone: string): TimezoneFormData => ({
    timezone
})
